'use strict';

var keyMirror = require('react/lib/keyMirror');

var VerticalDragAnchors = keyMirror({
  TOP: null,
  CENTER: null,
  BOTTOM: null
});

module.exports = VerticalDragAnchors;


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-dnd/dist-modules/constants/VerticalDragAnchors.js
 ** module id = 329
 ** module chunks = 0
 **/